import { useSelectorWithProps } from 'utils/structured-selector/structured-selector';

import { selectHasUserPermission } from 'store/selectors/app-selectors';

export const useExtraReportsPermissions = () => {
    const hasExtraRevampPermission = useSelectorWithProps(
        { permission: 'enable_fe_xtra_revamp_v1' },
        selectHasUserPermission,
    );

    const hasExtraRequestPermission = useSelectorWithProps(
        { permission: 'enable_xtra_request_v2_ff' },
        selectHasUserPermission,
    );

    const hasXtraRequestsTablePermission = useSelectorWithProps(
        { permission: 'enable_xtra_requests_table_v2_ff' },
        selectHasUserPermission,
    );

    const hasXtraPageAccessPermission = useSelectorWithProps(
        { permission: 'xtra_page_access_v2_ff' },
        selectHasUserPermission,
    );

    const hasOfflineReportsPermission = useSelectorWithProps(
        { permission: 'show_offline_reports' },
        selectHasUserPermission,
    );

    const hasSubmitReportOrderPermission = useSelectorWithProps(
        { permission: 'allow_placer_xtra_report_order' },
        selectHasUserPermission,
    );

    const hasDatePickerNavigatePermission = useSelectorWithProps(
        { permission: 'enable_option_to_move_months_on_datepicker' },
        selectHasUserPermission,
    );

    const hasReportSharingPermission = useSelectorWithProps(
        { permission: 'enable_xtra_reports_sharing' },
        selectHasUserPermission,
    );

    return {
        hasExtraRevampPermission,
        hasExtraRequestPermission,
        hasXtraPageAccessPermission,
        hasOfflineReportsPermission,
        hasSubmitReportOrderPermission,
        hasDatePickerNavigatePermission,
        hasReportSharingPermission,
        hasXtraRequestsTablePermission,
    };
};
